import { cn } from "@/lib/utils";
import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";
import { Badge } from "@/components/ui/badge";

export const MedInnCard = ({ inn }: { inn: MedInnPreviewVM }) => {
  const { name, slug, id } = inn;
  return (
    <Link
      className={cn(
        "group inline-flex items-start gap-4 overflow-hidden rounded-md border px-4 py-2.5",
      )}
      href={createPath("meds.inn.show", {
        slug: slug,
        id: id,
      })}
    >
      <Badge
        className={cn(
          `bg-remedium-blue mt-0.75 rounded-sm px-1 py-0 text-white`,
        )}
      >
        Sub. czynna
      </Badge>
      <span
        className={`group-hover:text-remedium-blue text-base font-semibold text-black transition-all`}
      >
        {name}
      </span>
    </Link>
  );
};
